<template>
  <div @click="optimizelyClick($event)">
    <button
      :class="className"
      :id="id"
      v-if="!isOptimizelyVariation && !forceAlwaysOn"
    >
      {{ label }}
    </button>
    <lightbox-button
      :target="target"
      :class="[className, className + '--optimizely']"
      :id="id"
      :optimizely-prefix="optimizelyPrefix"
      :prefix="prefix"
      v-else
      >{{ label }}</lightbox-button
    >
  </div>
</template>

<script>
import LightboxButton from './LightboxButton.vue';
import mktoAnalytics from '../marketo/marketo-analytics';

export default {
  props: [
    'optimizelyPrefix',
    'target',
    'youtubeId',
    'prefix',
    'href',
    'id',
    'className'
  ],
  data() {
    return {
      isOptimizelyVariation: !!window.optimizelyVariation,
      loaded: false,
      forceAlwaysOn: true,
      labelText: ''
    };
  },
  computed: {
    label() {
      let labelValue = 'Get Started';
      if (this.labelText) {
        labelValue = this.labelText;
      } else if (
        this.forceAlwaysOn ||
        this.isOptimizelyVariation ||
        window.optimizelyVariation
      ) {
        labelValue = 'Get Started';
      }
      return labelValue;
    }
  },
  components: {
    LightboxButton
  },
  methods: {
    optimizelyClick(e) {
      if (!this.optimizelyPrefix) {
        mktoAnalytics.setOptimizelyEvents('navTest', 'Click');
      }

      if (document.getElementById(this.id) !== null) {
        const linkText = document.getElementById(this.id).textContent.trim();
        dataLayer.push({
          event: 'navigation',
          navType: 'Main',
          navText: linkText
        });
      }

      if (!this.isOptimizelyVariation) {
        window.location = this.href;
      }
    }
  },
  mounted() {
    window.optimizelyVariation = true;

    if (window.skOptimizelyButtonText) {
      this.labelText = window.skOptimizelyButtonText;
    }

    window.addEventListener('DOMContentLoaded', () => {
      this.isOptimizelyVariation = !!window.optimizelyVariation;
      this.loaded = true;

      if (window.skOptimizelyButtonText) {
        this.labelText = window.skOptimizelyButtonText;
      }
    });
  }
};
</script>
